import { Component, OnInit, Input, Inject } from "@angular/core";

import { SideEffect, Rule } from "../../../../common/models/flow.dto";
import { genId } from "../../../../core/services/genId";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-return-work-item",
    templateUrl: "side-effect-return-work-item.component.html",
    standalone: false
})
export class SideEffectReturnWorkItemComponent implements OnInit {
    dateOptions = [{ id: "select", text: "..." }, { id: "time", text: "Set Timeframe" }, { id: "expression", text: "Custom Expression" }];
    sideEffect: SideEffect;

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
    }

    ngOnInit() {
        if (this.sideEffect && !this.sideEffect.configuration) 
            this.sideEffect.configuration = {};
    }

    changeDateType(): void {
        this.sideEffect.configuration.timeFrame = 0;
        this.sideEffect.configuration.rule = this.generateDefaultRule();
    }

    generateDefaultRule(): Rule {
        return {
            ruleId: genId(),
            name: "Due Date",
            expression: "",
            key: undefined,
            message: ""
        } as Rule;
    }

    isResubmitChanged(is: boolean): void {
        this.sideEffect.configuration.isResubmit = is;
    }
}